/**
 * Card connect related functions
 * and configuration
 */

export const cardconnectmixins = {
    data() {
        return {
            selectedcard  : null,
            cardconnecturl: '',
            cardname      : '',
            billingaddress: {
                billing_street_address   : '',
                billing_city             : '',
                billing_state            : '',
                billing_zip_code         : '',
                billing_address_latitude : '',
                billing_address_longitude: '',
            } 
        }
    },
    computed : {
         /**
         * Get and update card token
         * this will be used upon creating subscription
         */
          cardtoken : {
            get() {
                return this.$store.state.cardconnectdetails
            },
            set(token) {
                this.$store.commit('updatecarddetails', token);
            }
        }
    },
    methods : {
        /**
         * Listener for window message event
         * @param {Object} event 
         */
        eventlistner(event) {
            let data = null;
            // console.log('window event listner message', event);

            try {
                data = JSON.parse(event.data)
            } catch {
                data = event.data
            }
            const token = data ? data.message : null;

            if(token) {
                const carddetails = {
                    card_token          : token,
                    card_expiry         : data.expiry,
                    card_name           : this.cardname,
                    card_last_four_digit: token.substr(token.length - 4),
                    card_payment        : 'new_card'
                };

                const mergedetails = {
                    ...carddetails,
                    ...this.billingaddress
                }

                this.cardtoken    = mergedetails;
                this.selectedcard = null; // reset selected card if user tried to select from existing card
            }
        },
        /**
         * Card connect event listner
         * and configuration
         * this will generated token from iframe
         * for more documentation : https://developer.cardpointe.com/hosted-iframe-tokenizer#implementation-steps
         * 
         * @param {String} cardstyle custom css 
         */
         initcardconnect(cardstyle = "") {
            /**
             * Check if there's details
             */

            if(this.cardtoken) {
                this.cardname       = this.cardtoken.card_name
                this.billingaddress = this.cardtoken;
                this.selectedcard   = this.cardtoken.card_id ? this.usercreditcards.find(card => card.id == this.cardtoken.card_id).id : null;
            }

            /**
             * Card connect configuration
             * 
             */
            const baseurl = process.env.VUE_APP_CARDCONNECTBASEURL;

            const config = {
                /**
                 * Fields that will show
                 */
                usecvv   : true,
                useexpiry: true,
                 /**
                 * Fields configuration
                 */
                invalidinputevent : true,
                useexpiryfield    : true,
                invalidexpiryevent: true,
                // invalidcvvevent   : false,
                placeholder       : 'Card number',
                placeholdercvv    : 'CVV',
                placeholdermonth  : 'MM',
                placeholderyear   : 'YYYY',
                /**
                 * CSS styling
                 */
                cardlabel  : 'CARD DETAILS',
                expirylabel: ' ',
                cvvlabel   : ' ',
                css        : `label {font-family : sans-serif; font-size : 12px; font-weight : 600;} input{border-color : transparent; height : 30px; min-width : 20px;} .error{color : red;} input:focus{border-color : transparent; outline : none; box-shadow: none;} ${cardstyle}`
                
            }

            /**
             * Convert config object to url query string
             */
            const configurl  = Object.entries(config).map(o => o.join('=')).join('&')

            /**
             * Compose card connect url
             */
            this.cardconnecturl = encodeURI(`${baseurl}${configurl}`);
            

            /**
             * Listen for any message will throw
             */
            /**
             * Remove event listner first 
             * before adding new one.
             */
            window.removeEventListener('message', this.eventlistner);

            setTimeout(() => {
                window.addEventListener('message',this.eventlistner, true);
            }, 100);
        }
    },
    beforeDestroy() {
        /**
         * Remove all listner before leaving this page
         */
        window.removeEventListener('message', this.eventlistner);
    }
}